var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueApexCharts',{staticClass:"swap-chart",attrs:{"height":_vm.height || '100%',"width":_vm.width || '100%',"type":_vm.type || 'area',"options":{..._vm.base, ..._vm.options},"series":_vm.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }